<div class="print-request-container">
  <div class="header-contents">
    <div class="filters-section">
      <app-custom-date-select
        [(ngModel)]="selectedDate"
        placeholder="Select Meeting Date"
        class="date-select"
        [minDate]="minDate"
        [maxDate]="maxDate"
        selectionMode="month-year"
        (dateChange)="onDateSelected($event)"
      />
    </div>
  </div>
  <div class="table-contents">
    @if (showErrorPage) {
      <div class="error-row">
        <app-error-page [statusCode]="statusCode" />
      </div>
    } @else if (showLoadingSpinner) {
      <div class="modal-spinner">
        <app-nada-spinner [size]="100" />
      </div>
    } @else {
      <div class="print-request-data-container">
        @for (item of tableData; track item.Meeting_Id) {
          <div class="print-request-card">
            <div class="print-request-title">
              <p class="name">{{ item.Meeting_Name }}</p>
            </div>
            <div class="print-request-dates">
              <div class="arrival">
                <p class="arrival-name">Arrival Date</p>
                <p class="arrival-date">{{ item.Arrival_Date || "-" }}</p>
              </div>
              <div class="composite">
                <p class="composite-name">Composite Date</p>
                <p class="composite-date">{{ item.Comp_Month_Year || "-" }}</p>
              </div>
              <div class="modified">
                <p class="modified-name">Modified Date</p>
                <p class="modified-date">{{ item.Modified_Date || "-" }}</p>
              </div>
            </div>
            <div class="print-request-items">
              <div class="plus">
                <p class="plus-name">Plus</p>
                <p class="plus-value">{{ item.Plus_Display || "-" }}</p>
              </div>
              <div class="variable">
                <p class="variable-name">Variable</p>
                <p class="variable-value">{{ item.Variable_Display || "-" }}</p>
              </div>
              <div class="dgm">
                <p class="dgm-name">DGM</p>
                <p class="dgm-value">{{ item.DGM_Display || "-" }}</p>
              </div>
              <div class="classic">
                <p class="classic-name">Classic</p>
                <p class="classic-value">{{ item.Classic_Display || "-" }}</p>
              </div>
              <div class="fixed">
                <p class="fixed-name">Fixed</p>
                <p class="fixed-value">{{ item.Fixed_Display || "-" }}</p>
              </div>
            </div>
            <div class="print-request-details">
              <div class="home">
                <img
                  [src]="
                    item.Consultant_Home
                      ? '/assets/images/green-circle.svg'
                      : '/assets/images/red-circle.svg'
                  "
                  alt="Consultant Home"
                  class="home-img"
                />
                <p class="home-name">Consultant Home</p>
              </div>
            </div>
            <div class="print-request-notes">
              <p class="notes-name">Consultant Notes</p>
              <input
                class="notes-value"
                disabled
                type="text"
                [value]="item.Special_Instructions"
                placeholder="Add Note..."
              />
            </div>
            <div class="print-request-actions">
              <button
                class="save-print"
                (click)="onRequestPrint(item)"
                [disabled]="showModalSpinner"
              >
                {{ getButtonText() }}
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
@if (ShowModal) {
  <app-popup
    title="Request Print"
    primaryButtonText="Submit"
    secondaryButtonText="Cancel"
    [secondaryButtonFlat]="true"
    (closeClicked)="onModalClose()"
    (secondaryButtonClicked)="onModalClose()"
    (primaryButtonClicked)="updatePrintRequest()"
    [overflow]="'visible'"
  >
    <div class="popup-container">
      @if (showModalSpinner) {
        <div class="modal-spinner">
          <app-nada-spinner [size]="100" />
        </div>
      } @else if (meetingDetailsErrorMessage) {
        <p class="error-message">{{ meetingDetailsErrorMessage }}</p>
      } @else {
        <div class="popup-body">
          <div class="details-row">
            <div class="header-detail-item">
              <span class="header-detail-label">Group:</span>
              <span class="header-detail-value">{{
                currentSelectedMeetingDetails.Group_Code || "-"
              }}</span>
            </div>

            <div class="header-detail-item">
              <span class="header-detail-label">Consultant:</span>
              <span class="header-detail-value">{{
                currentSelectedMeetingDetails.Consultant || "-"
              }}</span>
            </div>

            <div class="header-detail-item">
              <span class="header-detail-label">Arrival Date:</span>
              <span class="header-detail-value">{{
                currentSelectedMeetingDetails.Arrival_Date || "-"
              }}</span>
            </div>
          </div>

          <div class="row-details">
            <div class="detail-row">
              <span class="detail-label">Email To:</span>
              <span class="detail-value">{{
                currentSelectedMeetingDetails.Consultant_Email || "-"
              }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Address:</span>
              <span class="detail-value">{{
                currentSelectedMeetingDetails.Location_Name || "-"
              }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">City:</span>
              <span class="detail-value">{{
                currentSelectedMeetingDetails.City || "-"
              }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">State:</span>
              <span class="detail-value">{{
                currentSelectedMeetingDetails.State || "-"
              }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Phone:</span>
              <span class="detail-value">{{
                currentSelectedMeetingDetails.Consultant_Phone || "-"
              }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Country:</span>
              <span class="detail-value">{{
                currentSelectedMeetingDetails.Country || "-"
              }}</span>
            </div>
          </div>
          <div class="comp-date">
            <p class="comp-title">Select Composite Date:</p>
            <app-custom-date-select
              [(ngModel)]="selectedCompDate"
              placeholder=" "
              class="comp-date-select"
              [minDate]="minDate"
              [maxDate]="maxDate"
              selectionMode="month-year"
              (dateChange)="onCompDateSelected($event)"
            />
          </div>
          <p class="detail-value copies">No.of Copies:</p>

          <div class="form-grid">
            <div class="form-group">
              <label>Plus</label>
              <input
                type="text"
                [(ngModel)]="currentSelectedMeetingDetails.Plus"
              />
            </div>

            <div class="form-group">
              <label>Classic</label>
              <input
                type="text"
                [(ngModel)]="currentSelectedMeetingDetails.Classic"
              />
            </div>

            <div class="form-group">
              <label>Variable</label>
              <input
                type="text"
                [(ngModel)]="currentSelectedMeetingDetails.Variable"
              />
            </div>

            <div class="form-group">
              <label>Fixed</label>
              <input
                type="text"
                [(ngModel)]="currentSelectedMeetingDetails.Fixed"
              />
            </div>

            <div class="form-group">
              <label>DGM</label>
              <input
                type="text"
                [(ngModel)]="currentSelectedMeetingDetails.DGM"
              />
            </div>
          </div>

          <div class="checkbox-group">
            <input
              type="checkbox"
              [(ngModel)]="
                currentSelectedMeetingDetails.Send_Plus_Book_To_Consultant_Home
              "
              id="consult-home"
            />
            <label for="consult-home">Send Plus book to Consultant home</label>
          </div>

          <div class="textarea-section">
            <p>Special Instructions</p>
            <textarea
              class="text-area"
              [(ngModel)]="currentSelectedMeetingDetails.Special_Instructions"
              placeholder="Add special instructions here..."
            ></textarea>
          </div>
        </div>
      }
    </div>
  </app-popup>
}
